import React from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { DevisModal } from './DevisModal';

export const Hero = () => {
  return (
    <section id="accueil" className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <Badge className="bg-green-100 text-green-700 hover:bg-green-100 border-green-200">
              <MapPin className="w-3 h-3 mr-1" />
              Artisan multiservices à Elven
            </Badge>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Votre artisan
              <span className="text-green-600"> multiservices</span> pour tous vos travaux
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Travaux de bricolage, jardinage, informatique... DMS David Multi Service intervient rapidement à Elven et communes aux alentours.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:0744921208" className="flex-1 sm:flex-initial">
                <Button size="lg" className="bg-green-600 hover:bg-green-700 text-white w-full sm:w-auto text-lg px-8 py-6">
                  <Phone className="w-5 h-5 mr-2" />
                  Appeler maintenant
                </Button>
              </a>
              <DevisModal 
                trigger={
                  <Button
                    size="lg"
                    variant="outline"
                    className="border-green-600 text-green-600 hover:bg-green-50 w-full sm:w-auto text-lg px-8 py-6"
                  >
                    Demander un devis
                  </Button>
                }
              />
            </div>

            {/* Info Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-8">
              <div className="flex items-start space-x-3 p-4 bg-white rounded-xl shadow-sm border border-gray-100">
                <Clock className="w-6 h-6 text-green-600 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900">Horaires</h3>
                  <p className="text-sm text-gray-600">Du lundi au samedi</p>
                  <p className="text-sm text-gray-600">À partir de 9h</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-white rounded-xl shadow-sm border border-gray-100">
                <MapPin className="w-6 h-6 text-green-600 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900">Zone d'intervention</h3>
                  <p className="text-sm text-gray-600">Elven et communes</p>
                  <p className="text-sm text-gray-600">alentours (Morbihan)</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Decorative Element */}
          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-green-200 rounded-3xl transform rotate-3"></div>
              <div className="relative bg-white p-8 rounded-3xl shadow-2xl transform -rotate-2">
                <div className="space-y-6">
                  <div className="flex items-center space-x-4 p-4 bg-green-50 rounded-xl">
                    <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-xl">✓</div>
                    <div>
                      <p className="font-semibold text-gray-900">Intervention rapide</p>
                      <p className="text-sm text-gray-600">Disponible rapidement</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4 p-4 bg-green-50 rounded-xl">
                    <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-xl">✓</div>
                    <div>
                      <p className="font-semibold text-gray-900">Travail soigné</p>
                      <p className="text-sm text-gray-600">Satisfaction garantie</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4 p-4 bg-green-50 rounded-xl">
                    <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-xl">✓</div>
                    <div>
                      <p className="font-semibold text-gray-900">Artisan local</p>
                      <p className="text-sm text-gray-600">Basé à Elven</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};